import React, { ReactNode } from 'react';
import { Box, Card, CardActionArea, CardContent, makeStyles } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

type Props = {
  children: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
};

type StyleProps = {
  isActive: boolean;
};

const useStyles = makeStyles((theme: HCPTheme) => ({
  card: {
    border: ({ isActive }: StyleProps) =>
      `1px solid ${isActive ? theme.palette.primary.main : theme.palette.grey[200]}`,
    borderRadius: '3px',
    transition: 'color .3s, border-color .3s, box-shadow .3s',
    overflow: 'hidden',

    '& p': {
      transition: 'color .3s',
    },

    '&:hover': {
      border: `1px solid ${theme.palette.info.light}`,
      boxShadow: theme.shadows[4],
      cursor: 'pointer',
      color: theme.palette.info.main,
      '& p': {
        color: theme.palette.info.main,
      },
    },
  },
  cardContent: {
    padding: 0,
  },
}));

export const OnlineBookingCard = ({ children, onClick, isActive = false }: Props) => {
  const { card, cardContent } = useStyles({ isActive });

  return (
    <Box mb={2}>
      <Card className={card}>
        <CardActionArea onClick={onClick}>
          <CardContent className={cardContent}>{children}</CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
};
